import { useEffect } from 'react'
import { useForm, useFormState } from 'react-hook-form'
import { useRouter } from 'next/router'

import Auth from 'store/auth'

import { postAxiosSingle } from 'pages/api/axios'
import { IObj } from 'constants/types/common.types'
import { FieldsNameVoc } from 'constants/auth/profile-data'
import { IDopRequestValues } from 'constants/types/consultation.types'
import { BASE_URL } from 'constants/url'

const useConsultationPurchase = (
  consultationFields?: string[],
  dopRequestValue?: IDopRequestValues,
  outerHandler?: () => void
) => {
  const { userProfile, isAuthorized } = Auth.useAuth()
  const router = useRouter()

  const onSubmit = async (values: IObj<string | number>) => {
    if (dopRequestValue?.courseId) values.courseId = dopRequestValue.courseId
    values.reason = dopRequestValue?.reason || ''
    values.type = dopRequestValue?.type || ''
    values.path = router.asPath

    const res = await postAxiosSingle(`${BASE_URL.NMO_COURSE}/consultation`, {}, values)

    if (res.status === 200 || res.status === 201) {
      outerHandler?.()
    }
  }

  const {
    handleSubmit,
    control,
    setValue,
    clearErrors,
    getValues,
    formState: { dirtyFields },
  } = useForm({
    mode: 'onBlur',
  })

  const { errors } = useFormState({ control })

  const isButtonDisabled = isAuthorized
    ? false
    : !(Object.keys(errors).length === 0 && Object.keys(dirtyFields).length >= 3)

  useEffect(() => {
    if (!consultationFields) return

    const { lastName, firstName, secondName } = userProfile
    const fullNameFromProfile = `${lastName || ''} ${firstName || ''} ${secondName || ''}`.trim()

    consultationFields.forEach((field) => {
      if (field === FieldsNameVoc.fullName && isAuthorized) {
        setValue(field, fullNameFromProfile)
        return
      }
      setValue(field, userProfile[field])
    })
  }, [userProfile])

  return {
    control,
    isButtonDisabled,
    clearErrors,
    handleSubmit,
    onSubmit,
    getValues,
    setValue,
    errors,
  }
}

const PAYMENT_POPUP_QUERY = 'paymentPopup'

export { PAYMENT_POPUP_QUERY, useConsultationPurchase }
